/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_Program_InfoInputs */



/**
* | output |
* | --- |
* | "Include Program Information" |
*
* @param {Subtitle_Export_Include_Program_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_program_info = /** @type {((inputs?: Subtitle_Export_Include_Program_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_Program_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure les informations sur le programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programminformationen einbeziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi informazioni sul programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включите информацию о программе.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir información del programa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包含项目信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラム情報を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम की जानकारी शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir informações sobre o programa")
	return /** @type {LocalizedString} */ ("Include Program Information")
});